import Api from '@/api/api';

const HTTP = {
    install(Vue) {
        Vue.prototype.$http = new Api();
    },
};

export default HTTP;
